import { InjectionToken } from '@angular/core';
import { CalendarRangeConfig } from './calendar-range-picker.service';

export const CALENDAR_RANGE_DIALOG_DATA = new InjectionToken<CalendarRangeConfig>('CALENDAR_RANGE_DIALOG_DATA');
